export default __webpack_public_path__ + "static/media/arrow-up-right.8e4c5697.svg";